'use client';

import Image from 'next/image';
import TypeIt from 'typeit-react';
import { useIsDesktop } from '@/shared/lib/react/useIsDesktop';
import { Typography } from '@/shared/ui/atoms';
import { SectionTitle } from '@/widgets/landing/medicontents/ui/molecules';
import * as S from './styles';

const SolutionSection = () => {
  const baseImageUrl = process.env.NEXT_PUBLIC_BASE_IMAGE_URL;
  const isLg = useIsDesktop();
  const title = isLg ? { text: '고객이 실제 궁금해하는\n의도(Intent) 데이터', position: 'text-start' } : { text: '고객이 실제 궁금해하는\n‘의도’를 담은 콘텐츠', position: 'text-center' };
  return (
    <section id="solution-section" className={S.section}>
      <SectionTitle title={title} eyebrow={{ text: `제로 클릭과 GEO의 해법`, position: 'text-center md:text-start', gap: 'mb-1.5 md:mb-1' }} />
      <div className={S.imageWrap}>
        <Image src={`${baseImageUrl}/medicontents/landing/search.gif?v=1.0`} alt="solution-1" fill sizes="33.125rem" className={S.image} />
      </div>
    </section>
  );
};

export default SolutionSection;
